import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Container, Typography, Box, CircularProgress, Alert } from '@mui/material';
import { API_BASE_URL } from '../../utils/api';

const typeToTitle = {
  terms: 'Terms of Service',
  privacy: 'Privacy Policy',
  roommate_terms: 'Roommate Terms of Service',
};

export default function TermsPage() {
  const location = useLocation();
  const qsType = new URLSearchParams(location.search).get('type') || 'terms';
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [content, setContent] = useState('');
  const [title, setTitle] = useState(typeToTitle[qsType] || 'Policy');

  useEffect(() => {
    let active = true;
    async function load() {
      try {
        setLoading(true);
        setError('');
        const res = await fetch(`${API_BASE_URL}/auth/terms/?type=${encodeURIComponent(qsType)}`);
        if (!res.ok) {
          const text = await res.text();
          throw new Error(text || `HTTP ${res.status}`);
        }
        const data = await res.json();
        if (!active) return;
        setTitle(data.title || typeToTitle[qsType] || 'Policy');
        setContent(data.content || '');
      } catch (e) {
        if (!active) return;
        setError('Failed to load policy content.');
      } finally {
        if (active) setLoading(false);
      }
    }
    load();
    return () => { active = false; };
  }, [qsType]);

  const isHtml = /<\w+[^>]*>/.test(content || '');

  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h4" gutterBottom sx={{ textAlign: 'center', mb: 4 }}>
        {title}
      </Typography>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 6 }}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Alert severity="error">{error}</Alert>
      ) : content ? (
        isHtml ? (
          <Box sx={{ '& p': { lineHeight: 1.8 }, '& h1, & h2, & h3': { mt: 3 } }} dangerouslySetInnerHTML={{ __html: content }} />
        ) : (
          <Typography variant="body1" sx={{ whiteSpace: 'pre-line', lineHeight: 1.8 }}>
            {content}
          </Typography>
        )
      ) : (
        <Typography variant="body2" color="text.secondary">No content.</Typography>
      )}
    </Container>
  );
} 